export default __webpack_public_path__ + "transfix-maps/icons/D5-newWave.b99510abb26a9a3829cb66630ecf294a.png";